const Logo = ({ size = 48 }) => (
  <img
    src="/logo.jpg"
    alt="Mini Muslims Nest"
    style={{ height: size, width: "auto", objectFit: "contain" }}
  />
);

export default Logo;
